import DefaultRoutes from "./DefaultRoutes";
import MapRoutes from "./MapRoutes";

export default class Routes {
  static Default = DefaultRoutes;
  static Maps = MapRoutes;
}
